import { SafeAreaContainer } from 'lincd-capacitor/components/SafeAreaContainer';
import { cl } from 'lincd/utils/ClassNames';
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { ROUTES } from '../routes.js';
import style from './DefaultLayout.module.css';

export function DefaultLayout({
  children,
  backgroundColor = 'gray',
  safeareaBackground = '#FFFFFF',
  className,
}: {
  children;
  className?: string;
  safeareaBackground?: string;
  backgroundColor?: 'white' | 'gray' | 'dark';
}) {
  const location = useLocation();

  /**
   * disable safearea background color to transparent, so that make the background will be transparent.
   * but the padding for safearea still available.
   *
   * normally use this when you want to make background image/color fullscreen
   */
  const isFullscreen = location.pathname === ROUTES.signin.path;

  return (
    <main className={cl(style.main, style[backgroundColor])}>
      <SafeAreaContainer
        color={isFullscreen ? 'transparent' : safeareaBackground}
      >
        <div>{children}</div>
      </SafeAreaContainer>
    </main>
  );
}
